export const platformList = Object.freeze({
  bigcommerce: 'bigcommerce',
  magento: 'magento',
  woocommerce: 'woocommerce',
  commercecloud: 'commercecloud',
  sdk: 'sdk',
});

export const pluginList = {
  shippingProtection: 'shipping-protection',
  custumerSignature: 'customer-signature',
};

export const addressShape = {
  apartmentUnit: '',
  city: '',
  companyName: '',
  country: '',
  countryIso2: '',
  state: '',
  stateLong: '',
  street: '',
  streetName: '',
  streetNumber: '',
  userInputSingleLine: '',
  zip: '',
};

export const autofillSource = Object.freeze({
  EMAIL_RESPONSE: 'EMAIL_RESPONSE',
  MANUAL_ADDRESS: 'MANUAL_ADDRESS',
  GOOGLE_AUTOCOMPLETION_SERVICE: 'GOOGLE_AUTOCOMPLETION_SERVICE',
  SMARTY_US_AUTOCOMPLETE: 'SMARTY_US_AUTOCOMPLETE',
});

export const validationSource = Object.freeze({
  FROM_TYPING: 'FROM_TYPING',
  FROM_SUBMIT: 'FROM_SUBMIT',
});

export const defaultCurrency = {
  baseCurrency: 'USD',
  displayCurrency: 'USD',
  exchangeRate: 1,
  precision: 2,
  separator: {
    radix: '.',
    thousand: ',',
  },
  symbol: {
    token: '$',
    position: 'left',
  },
};

export const deliveryMethod = Object.freeze({
  shipping: 'shipping',
  pickup: 'pickup',
});
